import { createContext, useContext } from "react";
export const GridSelectProducerContext = createContext(undefined);
const NOOP = () => { };
/** @internal The publish function, or a no-op if there's no `<ArtisAppProvider>` above. */
export const useGridSelectProducer = () => useContext(GridSelectProducerContext) ?? NOOP;
//# sourceMappingURL=gridSelectProducer.js.map